import React from "react";
import { useApp } from "@/context/AppContext";
import { LANGUAGES } from "@/lib/i18n";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Globe, Check } from "lucide-react";

export default function LanguageSelector({ testid = "language-selector" }) {
  const { lang, setLang, settings } = useApp();
  const active = new Set(settings?.active_languages || ["en", "hi", "mr", "ta"]);
  const options = LANGUAGES.filter((l) => active.has(l.code));
  const current = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid={testid}
        className="inline-flex items-center gap-2 rounded-full border border-border/70 bg-background/60 px-3 py-1.5 text-xs font-medium text-secondary/90 backdrop-blur hover:bg-background focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/30"
      >
        <Globe className="h-4 w-4" aria-hidden />
        <span data-testid="current-language-label">{current.native}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-40">
        {options.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-option-${l.code}`}
            onClick={() => setLang(l.code)}
            className="flex items-center justify-between gap-4"
          >
            <span>
              <span className="font-medium">{l.native}</span>
              <span className="ml-2 text-xs text-muted-foreground">{l.label}</span>
            </span>
            {l.code === lang && <Check className="h-4 w-4 text-primary" aria-hidden />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
